Vue.component('vq-file', {
	delimiters: ['[[', ']]'],
	props: {
		label: String,
		labelClasses: String,
		model: Object,
		name: String,
		placeholder: String
	},
	data: function () {
		return {
			initialPlaceholder: this.placeholder
		};
	},
	computed: {
		sync_model: {
			get() {
				return this.model.value;
			},
			set(val) {
				this.$emit('update:model', { value: val });
			}
		},
		sync_placeholder: {
			get() {
				return this.placeholder;
			},
			set(val) {
				this.$emit('update:placeholder', val);
			}
		}
	},
	methods: {
		change(event) {
			let file = event.target.files[0];
			if (file) {
				if (
					file &&
					['image/jpeg', 'image/png', 'application/pdf'].includes(file.type) &&
					file.size <= 5242880
				) {
					this.sync_model = file;
					this.sync_placeholder = file.name;
				}
			} else {
				this.sync_model = '';
				this.sync_placeholder = this.initialPlaceholder;
			}
		}
	},
	mounted() {
		if (!this.model.value) {
			this.$emit('update:model', { value: '' });
		}
	},
	template: `<div class="form-control">
	<span class="label pb-5" :class="labelClasses" v-if="label">[[label]]</span>  
	<div class="wrapper">
	  <input class="input is-file" :class="{'is-empty': sync_model == '' }" @change="change($event)" type="file" :name="name" :id="name" accept=".pdf, .docx, .doc, .jpg, .png">
	  <label :for="name">
	  	<span class="filename ellipsis">[[sync_placeholder]]</span>
	  	<i class="icon icon-attachment"></i>
	  	<i class="icon icon-check"></i>
	  </label>
	</div>          
</div>  `
});
